import { createAsyncThunk } from '@reduxjs/toolkit';
import type SocketClient from '../../../../services/socket/SocketClient';
import type { GridDeleteType } from './saveHandlers';
import type { ErrorCode } from '../../../../services/socket/SocketEvents';
import { AcknowledgmentResponseStatus } from '../../../../services/socket/SocketEvents';
import { BlockEvents } from '../../../../services/socket/SocketEvents';

export type GridDeletedSocketResponseType = { status: AcknowledgmentResponseStatus; content: string; errorCode: ErrorCode };
type GridDeletedCallbackType = (gridDeletedSocketResponse: GridDeletedSocketResponseType) => void;
export const deleteBlockWithSocket = createAsyncThunk(
  'editor-grid-block/deleteGridWithSocket',
  async (payload: { blockId: string; socketClient: SocketClient; userId: number; callback: GridDeletedCallbackType }) => {
    const { blockId, callback, socketClient } = payload;

    const data: GridDeleteType = {
      blockId: blockId,
    };
    return new Promise<GridDeletedSocketResponseType>((resolve) => {
      socketClient.publish(BlockEvents.BLOCK_DELETED, data, (responseParsed: GridDeletedSocketResponseType) => {
        callback(responseParsed);
        resolve(responseParsed);
      });
    });
  }
);

export type GridNewDeletedSocketResponseType = {
  status: AcknowledgmentResponseStatus;
  content?: {
    blockId?: string;
  };
  errorCode: ErrorCode;
};
type GridNewDeletedCallbackType = (gridDeletedSocketResponse: GridNewDeletedSocketResponseType) => void;

export const deleteNewBlockWithSocket = createAsyncThunk(
  'editor-grid-block/deleteGridWithSocket',
  async (payload: { blockId: string; socketClient: SocketClient; userId: number; callback: GridNewDeletedCallbackType }) => {
    const { blockId, callback, socketClient } = payload;

    const data: GridDeleteType = {
      blockId: blockId,
    };
    return new Promise<GridNewDeletedSocketResponseType>((resolve, reject) => {
      socketClient.publish(BlockEvents.BLOCK_DELETED, data, (socketResponse: any) => {
        const typedResponse: GridNewDeletedSocketResponseType = {
          status: socketResponse.status || AcknowledgmentResponseStatus.FAILURE,
          errorCode: socketResponse.errorCode || null,
          content: {
            blockId: socketResponse.content?.blockId || blockId,
          },
        };

        callback(typedResponse);

        if (typedResponse.status === AcknowledgmentResponseStatus.OK) {
          resolve(typedResponse);
        } else {
          reject(new Error(typedResponse.errorCode || 'Delete failed'));
        }
      });
    });
  }
);
